import { Platform } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { LabelService } from 'src/app/services/label/label.service';
import { VendorService } from 'src/app/services/vendor/vendor.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { encodeURL } from 'src/app/services/parseURL';

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss'],
})
export class ShowcaseComponent implements OnInit {

  @Input() product;
  @Input() style: any;
  currencyCode: any;
  loading: any;
  SHARED_LABELS: any = {};
  showProductPrices: boolean;
  useThumb: boolean;
  constructor(private router: Router,
    private platform: Platform,
    private labelService: LabelService,
    private configService: ConfigService,
    private vendorService: VendorService,) {
  }

  async ngOnInit() {
    // this.showProductPrices = await this.sharedNewService.showPrices();
    this.platform.ready().then(() => {
      let deviceWidth = this.platform.width();
      if (deviceWidth > 786) {
        this.useThumb = false;

      } else {
        this.useThumb = true;
      }
    });
    this.currencyCode = this.configService.environment.currencyCode;
    this.SHARED_LABELS = this.labelService.labels['SHARED'];
  }

  onClickProduct(id: string, product: any) {
    const navigationExtras: NavigationExtras = {
      state: {
        productId: id,
      }
    };
    if (product.data.hasOwnProperty('ptype') && product.data.ptype === 'child') {
      navigationExtras.state.productId = product.data.parentId;
    }
    this.router.navigate(['product-details'], navigationExtras);
  }

  getDiscountPercent(discountedPrice, prodPrice) {
    if (prodPrice > discountedPrice) {
      const discount = Math.round(((prodPrice - discountedPrice) / prodPrice) * 100);
      return discount;
    } else {
      return 0;
    }
  }

  removeHtml(desc) {
    const tagsRemoved = desc.replace(/(<([^>]+)>)/ig, '');
    const plainTxt = document.createElement('textarea');
    plainTxt.innerHTML = tagsRemoved;
    return plainTxt.value;
  }

  isEmptyObj(object) {
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getImgUrl() {
    let useThumb = false;
    if (this.platform.width() <= 786) {
      useThumb = true;
    }
    const imgType = useThumb ? 'thumb' : 'mob';
    if (this.product.data.coverPic && this.product.data.coverPic[imgType]) {
      return this.product.data.coverPic[imgType];
    }
    if (this.product.data.coverPic && !this.product.data.coverPic[imgType] && this.product.data.coverPic.url) {
      return this.product.data.coverPic.url;
    }
    if (!this.product.data.coverPic || (!this.product.data.coverPic[imgType] && !this.product.data.coverPic.url)) {
      return "assets/img/placeholder-img.jpg";
    }
  }

  onClickVendor(product) {
    const navigationExtras: NavigationExtras = {
      state: {
        vendorName: product.data.vendorName,
        vendorId: product.data.vendorId
      }
    }
    this.router.navigate(['vendor-info'], navigationExtras);
  }

  showVendorInfo(vendorName) {
    return this.vendorService.vendorSettings.showVendorInfo && vendorName;
  }

  urlPdtName(pname: string) {
    return encodeURL(pname);
  }

}
